import { ExternalLink } from "@octopusdeploy/design-system-components";
import { useMemo } from "react";
import { resolveGitRevisionUrl } from "~/areas/projects/components/Observability/ObjectDrawer/Tabs/components/resolveGitRevisionUrl";
type RevisionProps = {
    revision: string;
    repositoryUrl: string;
};
function truncate(value: string, maxLength: number): string {
    const truncateLength = Math.min(maxLength, value.length);
    return value.substring(0, truncateLength);
}
export const Revision = (props: RevisionProps) => {
    const { revision, repositoryUrl } = props;
    const length = revision.startsWith("sha256:") ? 14 : 7;
    const rev = truncate(revision, length);
    const resolvedUrl = useMemo(() => resolveGitRevisionUrl(repositoryUrl, revision), [repositoryUrl, revision]);
    return <span>{resolvedUrl ? <ExternalLink href={resolvedUrl}>{rev}</ExternalLink> : <span title={revision}>{rev}</span>}</span>;
};
